import { createApp } from "vue";
import { createPinia } from "pinia";
import { VueQueryPlugin } from "@tanstack/vue-query";
import App from "./App.vue";
import router from "./router";
import "./scss/styles.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import Vueform from "@vueform/vueform";
import theme from "@vueform/vueform/dist/bootstrap";
import "@vueform/vueform/dist/bootstrap.css";
import en from "@vueform/vueform/locales/en";

import { createVueQueryClient } from "@/queries/vue-query-client";

export function setup() {
  const app = createApp(App);

  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);
  app.use(pinia);

  app.use(router);

  const queryClient = createVueQueryClient();
  app.use(VueQueryPlugin, { queryClient });

  app.use(Vueform, {
    theme,
    locale: "en",
    locales: { en },
    displayErrors: true,
    displayMessages: true,
  });

  app.mount("#app");
}
